<template>
    <div>
      <input v-model="payment.amount" placeholder="Monto" type="number">
      <select v-model="payment.currency">
        <option value="USD">USD</option>
        <option value="COP">COP</option>
      </select>
      <button @click="submitPayment">Pagar</button>
    </div>
  </template>
  
  <script>
  import api from "@/services/api";
  
  export default {
    data() {
      return {
        payment: {
          amount: 0,
          currency: 'USD'
        }
      };
    },
    methods: {
      submitPayment() {
        api.post('/kushki/pay', this.payment)
          .then(response => {
            alert('Pago procesado: ' + response.data);
          })
          .catch(error => {
            console.error('Error al procesar el pago:', error);
          });
      }
    }
  }
  </script>  